/*-------------------------
      FILTER RANGE
 ------------------------*/
FilterRange = {
    init: function () {
        var iterationCount = 0;
        var rangeBgColor = '#e0e0e0';
        var rangeActiveColor = '#000000';

        function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
            const [from, to] = getParsed(fromInput, toInput);
            fillSlider(fromInput, toInput, rangeBgColor, '#000000', controlSlider);
            if (from > to) {
                fromSlider.value = to;
                fromInput.value = to;
            } else {
                fromSlider.value = from;
            }
        }

        function controlToInput(toSlider, fromInput, toInput, controlSlider) {
            const [from, to] = getParsed(fromInput, toInput);
            fillSlider(fromInput, toInput, rangeBgColor, '#000000', controlSlider);
            setToggleAccessible(toInput);
            if (from <= to) {
                toSlider.value = to;
                toInput.value = to;
            } else {
                toInput.value = from;
            }
        }

        function controlFromSlider(fromSlider, toSlider, fromInput) {
            const [from, to] = getParsed(fromSlider, toSlider);
            fillSlider(fromSlider, toSlider, rangeBgColor, '#000000', toSlider);
            if (from > to) {
                fromSlider.value = to;
                fromInput.value = to;
            } else {
                fromInput.value = from;
            }
        }

        function controlToSlider(fromSlider, toSlider, toInput) {
            const [from, to] = getParsed(fromSlider, toSlider);
            fillSlider(fromSlider, toSlider, rangeBgColor, '#000000', toSlider);
            setToggleAccessible(toSlider);
            if (from <= to) {
                toSlider.value = to;
                toInput.value = to;
            } else {
                toInput.value = from;
                toSlider.value = from;
            }
        }

        function getParsed(currentFrom, currentTo) {
            const from = parseInt(currentFrom.value, 10);
            const to = parseInt(currentTo.value, 10);
            iterationCount++;
            rangeModied(from, to, iterationCount);
            return [from, to];
        }

        function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
            const rangeDistance = to.max - to.min;
            const fromPosition = from.value - to.min;
            const toPosition = to.value - to.min;
            controlSlider.style.background = `linear-gradient(
                to right,
                ${sliderColor} 0%,
                ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
                ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
                ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
                ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
                ${sliderColor} 100%)`;
        }

        function setToggleAccessible(currentTarget) {
            const toSlider = document.querySelector('#toSlider');
            if (Number(currentTarget.value) <= 0) {
                toSlider.style.zIndex = 2;
            } else {
                toSlider.style.zIndex = 0;
            }
        }

        function rangeModied(min, max, iterationCountStart) {

            console.log(Math.round(min));
            console.log(Math.round(max));
            console.log("----------");
            timeout = setTimeout(function () {
                if (iterationCount == iterationCountStart) {
                    updateFilter(min, max);
                }
            }, 1000);
        }

        function updateFilter(min, max) {
            $(".collection__products").animate({ opacity: .5 }, 100);
            $(".filter-group-display__price-range .range-min-price").val(Math.round(min));
            $(".filter-group-display__price-range .range-max-price").val(Math.round(max));
            $(".range-apply").trigger("click");
        }

        const fromSlider = document.querySelector('#fromSlider');
        const toSlider = document.querySelector('#toSlider');
        const fromInput = document.querySelector('#fromInput');
        const toInput = document.querySelector('#toInput');
        fillSlider(fromSlider, toSlider, rangeBgColor, '#000000', toSlider);
        setToggleAccessible(toSlider);

        fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
        toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
        fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
        toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);


        // Prevent reload on submit
        $("#SSLLrangeForm input").keypress(function (e) {
            if (e.which == 13) {
                $(".collection__products").animate({ opacity: .5 }, 100);
                e.preventDefault();
                $(".range-apply").trigger("click");
            }
        });
    }
};

$(function () {
    FilterRange.init();
});